import React from 'react';

export default ( { className, fill, ...props } ) => (
    <svg width="24" height="24" className={ className } { ...props } viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 16L5 9.43L6.38 8L12 13.28L17.62 8L19 9.43L12 16Z" fill={ fill || 'currentColor' } />
    </svg>
);
